import invoiceEditor from './index.js';
import _ from 'lodash';
import moment from 'moment';

const uuidv1 = require('uuid/v1');

const SET_SEARCHED_CUSTOMERS = (state, searchedCustomers) => {
  state.searchedCustomers = searchedCustomers;
};

const SET_CUSTOMERS_LOADING = (state, customersLoading)=>{
  state.customersLoading = customersLoading;
}

const SET_INVOICE_CUSTOMER = (state, customer)=>{
  state.invoice.customer = customer;

}

const SET_INVOICE_CURRENCY = (state, currency)=>{
  state.invoice.currency = currency;
}


const SET_INVOICE_BILLING_ADDRESS = (state, billingAddress)=>{
  state.invoice.billingAddress = billingAddress;
}

const SET_INVOICE_SHIPPING_ADDRESS = (state, shippingAddress)=>{
  state.invoice.shippingAddress = shippingAddress;
}

const SET_CUSTOMER_CONTACTS = (state, contacts) => {
  state.customerContacts = contacts;
}
const SET_BILLING_CONTACT = (state, contact) => {
  state.invoice.billingContact = contact;
}

const SET_SHIPPING_CONTACT = (state, contact) => {
  state.invoice.shippingContact = contact;
}

const SET_INVOICE_DATE = (state, date) =>{
  state.invoice.date = date;
}

const SET_INVOICE_DUE_DATE = (state, dueDate)=>{
  state.invoice.dueDate = dueDate;
}

const SET_INVOICE_TERM = (state, term) =>{
  state.invoice.term = term;
}

const SET_INVOICE_ITEMS_LOADING = (state, invoiceItemsLoading) => {
  state.invoiceItemsLoading = invoiceItemsLoading;
}

const ADD_ITEM_LINE_ITEM = (state, {productInfos, qty})=>{
  let newProductLine = _.cloneDeep(state.defaultItem);
  if (_.get(productInfos, 'product.saleAccount') != null) {
    productInfos.account = productInfos.product.saleAccount;
  } else {
    productInfos.account = null; 
  }
  Object.assign(newProductLine, productInfos);
  newProductLine.uuid = uuidv1();
  newProductLine.qty = qty;
  
  state.invoice.lines.push(newProductLine);
}

const SET_ITEM_LINE_PROPERTY = (state,{uuid, propName, propVal, priceIndex})=>{
  let itemLine  = _.find(state.invoice.lines, line=> line.uuid === uuid);
  if(propName==="discount"){
    if(itemLine[propName] == null) itemLine[propName] = {};
    Object.assign(itemLine[propName], propVal);
  }else if(propName==="price"){
    itemLine.prices[priceIndex].price = propVal;
  }else{
    itemLine[propName]=propVal;
  }
};

const SET_INVOICE_PAYMENT_METHODS = (state, paymentMethods)=>{
  state.invoice.paymentTypes = paymentMethods;
}

const SET_INVOICE_NOTES = (state, notes) =>{
  state.invoice.notes = notes;
}


const CLONE_INVOICE = (state, invoice)=>{
  state.invoice = _.cloneDeep(invoice);

  _.forEach(state.invoice.lines, (line) =>{
    line.uuid = uuidv1();
    if (line.account == undefined ) line.account= null;
    if (line.discount == null) {
      line.discount = {
        amount: null,
        creditType : null,
        netType: null,
        value: null
      }
    }
  })
}

const SET_INVOICE_TERMS = (state, terms)=>{
  state.terms = terms;
}

const RESET = (state)=>{
  Object.assign(state, invoiceEditor.getDefaultState());
  state.lines = [];
}

const SET_SUB_TOTAL = (state, sub_total)=>{
  state.invoice.subTotal = sub_total;
}

const SET_TOTAL = (state, total)=>{
  state.invoice.total = total;
}

const SET_TAXES = (state, taxes)=>{
  state.invoice.taxes = taxes;
}

const UPDATE_ITEM_LINES = (state, itemLines)=>{
  state.invoice.lines = itemLines;


  // _.forEach(itemLines, (line, key)=>{
  //
  //   _.forEach(line.prices, p=>{
  //     p.editState = false;
  //   })
  //   state.invoice.lines[key].discount = line.discount;
  //   state.invoice.lines[key].prices = line.prices;
  //   state.invoice.lines[key].subTotal = line.subTotal;
  //   state.invoice.lines[key].taxableAmount = line.taxableAmount;
  //   state.invoice.lines[key].taxAmount = line.taxAmount;
  //   state.invoice.lines[key].subTotalBrut = line.subTotalBrut;
  // })
}

const REMOVE_INVOICE_ITEM_LINE = (state, index)=>{
  state.invoice.lines.splice(index,1);
}

const SET_EDIT_PRICE_FLAG = (state, {uuid, editState, index})=>{
  let itemLine  = _.find(state.invoice.lines, line=>{return line.uuid==uuid});
    itemLine.prices[index].editState=editState;
}

const SET_SHOW_TIERCE_AGENCY_OUTSTANDING = (state, show_tierce_agency_outstanding)=>{
  state.invoice.showTierceAgencyOutstanding =show_tierce_agency_outstanding;
}

const SET_SHOW_DETAILED_PRICES = (state, detailedPrices)=>{
  state.invoice.detailedPrices =detailedPrices;
}

const SET_CREDIT_NOTES = (state, creditNotes) =>{
  state.creditNotes = creditNotes;
}

const APPLY_CREDIT_NOTES = (state, creditNotes) =>{
  state.invoice.creditNotes = creditNotes;
}
const SET_INVOICE_LOADING = (state, loading) =>{
  state.invoiceLoading = loading;
}

const SET_SALES_REP = (state, salesRep) => {
  state.invoice.rep = salesRep;
}

const SET_EDIT_STATE = (state, editState) => {
  _.forEach(state.invoice.lines, line => {
    _.forEach(line.prices, p=>{
        p.editState = editState;
      })
  })
}

const SET_INVOICE_NUMBER_REFERENCE = (state, invoiceNumberReference) => {
  state.invoice.invoiceNumberReference = invoiceNumberReference;
}

const SET_GLOBAL_DISCOUNT = (state, discount) => {
  const clonedDiscount = _.cloneDeep(discount);
  state.invoice.discount = clonedDiscount;
}

export default {
  SET_INVOICE_LOADING,
  SET_SEARCHED_CUSTOMERS,
  SET_CUSTOMERS_LOADING,
  SET_INVOICE_CUSTOMER,
  SET_INVOICE_BILLING_ADDRESS,
  SET_INVOICE_SHIPPING_ADDRESS,
  SET_CUSTOMER_CONTACTS,
  SET_BILLING_CONTACT,
  SET_SHIPPING_CONTACT,
  SET_INVOICE_DATE,
  SET_INVOICE_DUE_DATE,
  SET_INVOICE_TERM,
  SET_INVOICE_ITEMS_LOADING,
  ADD_ITEM_LINE_ITEM,
  SET_ITEM_LINE_PROPERTY,
  SET_INVOICE_PAYMENT_METHODS,
  SET_INVOICE_NOTES,
  CLONE_INVOICE,
  SET_INVOICE_TERMS,
  RESET,
  SET_SUB_TOTAL,
  SET_TOTAL,
  SET_TAXES,
  UPDATE_ITEM_LINES,
  REMOVE_INVOICE_ITEM_LINE,
  SET_EDIT_PRICE_FLAG,
  SET_SHOW_TIERCE_AGENCY_OUTSTANDING,
  SET_INVOICE_CURRENCY,
  SET_CREDIT_NOTES,
  APPLY_CREDIT_NOTES,
  SET_SALES_REP,
  SET_EDIT_STATE,
  SET_INVOICE_NUMBER_REFERENCE,
  SET_GLOBAL_DISCOUNT,
  SET_SHOW_DETAILED_PRICES
};
